
export default function RecruitmentBranding() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Text Area - 40% */}
          <div className="lg:col-span-2">
            <h2 className="text-4xl font-bold mb-6 leading-tight text-[#1a2332]" style={{ fontFamily: 'Noto Serif JP, serif' }}>
              「全席、考え抜かれたオフィスチェア。」<br />
              それは、最も雄弁な<br />
              ホワイト企業メッセージです。
            </h2>
            <p className="text-base leading-relaxed text-[#4a4a4a] mb-8">
              採用市場で選ばれる企業は、「働く環境」を本気で整えています。MeVERの導入は、求職者に対する最も明確なメッセージとなります。
            </p>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xl text-[#3d6b4a]"></i>
                </div>
                <div>
                  <div className="font-bold text-[#1a2332] mb-1">採用力の向上</div>
                  <div className="text-sm text-[#4a4a4a]">オフィス見学時の印象が劇的に変わります</div>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xl text-[#3d6b4a]"></i>
                </div>
                <div>
                  <div className="font-bold text-[#1a2332] mb-1">離職率の低下</div>
                  <div className="text-sm text-[#4a4a4a]">快適な環境が定着率を高めます</div>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xl text-[#3d6b4a]"></i>
                </div>
                <div>
                  <div className="font-bold text-[#1a2332] mb-1">エンゲージメント向上</div>
                  <div className="text-sm text-[#4a4a4a]">「会社が自分を大切にしている」実感</div>
                </div>
              </li>
            </ul>
          </div>

          {/* Right Visual Area - 60% */}
          <div className="lg:col-span-3 relative">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/1b3831a759e43434f98eb4be3ecfd207.jpeg"
                alt="オフィス環境"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
              {/* Overlay Card */}
              <div className="absolute bottom-8 right-8 bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl max-w-xs">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <div className="text-3xl font-bold text-[#3d6b4a] mb-1">-30%</div>
                    <div className="text-xs text-[#4a4a4a]">離職率低下</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-[#2c4a6e] mb-1">+45%</div>
                    <div className="text-xs text-[#4a4a4a]">採用力向上</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
